"use client";

import { useEffect } from "react";
import Link from "next/link";

/**
 * Root error boundary for the Next.js App Router. Catches errors thrown during
 * render of any route segment that doesn't have a more specific error.tsx.
 * Renders inside the root <body>, so the layout chrome is gone — keep this
 * page self-contained.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error("[app/error]", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f5ede4] px-6 py-12 text-[#25442a]">
      <div className="w-full max-w-md rounded-2xl border-2 border-[#3c5c40] bg-[#dcbfa6] p-8 shadow-lg">
        <h1 className="mb-3 font-bangers text-3xl uppercase tracking-wide text-[#bd4b37]">
          Algo salió mal
        </h1>
        <p className="mb-6 text-sm text-[#25442a]/80">
          Ha ocurrido un error inesperado. Puedes intentar reintentar la última
          acción o volver al inicio.
        </p>
        <div className="flex flex-wrap gap-3">
          <button
            type="button"
            onClick={reset}
            className="rounded-lg bg-[#25442a] px-4 py-2 text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#1a2f1d]"
          >
            Reintentar
          </button>
          <Link
            href="/map"
            className="rounded-lg border-2 border-[#25442a] bg-transparent px-4 py-2 text-sm font-bold uppercase tracking-wide text-[#25442a] transition-colors hover:bg-[#25442a]/10"
          >
            Volver al mapa
          </Link>
        </div>
        {error.digest && (
          <p className="mt-6 font-jetbrains text-[10px] uppercase tracking-widest text-[#25442a]/40">
            ref: {error.digest}
          </p>
        )}
      </div>
    </div>
  );
}
